import { gql } from '@apollo/client';
/**
 * @const GetMewsRatesQuery
 * @since 1.0.0
 */
export const GetMewsRatesQuery = gql `
  query GetMewsRates($input: GetMewsRatesInput!) {
    getMewsRates(input: $input) {
      rates {
        id
        name
      }
    }
  }
`;
